import moment from 'moment';
import ApiService from './api.service';

// actions
export const GET_HOMECONTENT = 'getHomeContent';
export const GET_PARENTSECTION = 'getParentSection';

export const ADD_SECTIONCONTENT = 'addSectionContent';
export const ADD_MENU_CONTENT = 'addMenuSectionContent';
export const ADD_ITEM_CONTENT = 'addItemSectionContent';
export const ADD_CATEGORY_CONTENT = 'addCategorySectionContent';

export const UPDATE_SECTIONCONTENT = 'updateSectionContent';
export const UPDATE_MENU_CONTENT = 'updateMenuContent';
export const UPDATE_ITEM_CONTENT = 'updateItemContent';
export const UPDATE_CATEGORY_CONTENT = 'updateCategoryContent';
export const UPDATE_STATUS_CATEGORY_CONTENT = 'updateStatusCategoryContent';
export const UPDATE_STATUS_MENU_CONTENT = 'updateStatusMenuContent';
export const UPDATE_STATUS_ITEM_CONTENT = 'updateStatusItemContent';

export const DETAIL_SECTIONCONTENT = 'detailSectionContent';
export const DETAIL_MENU_CONTENT = 'detailMenuContent';
export const DETAIL_ITEM_CONTENT = 'detailItemContent';
export const DETAIL_CATEGORY_CONTENT = 'detailCategoryContent';

export const DELETE_SECTIONCONTENT = 'deleteSectionContent';

export const GET_MENU = 'getMenuCategories';
export const GET_SUB_CATEGORIES = 'getSubCategories';
export const GET_ITEMS = 'getItems';
// mutations
export const SET_HOMECONTENT = 'setHomeContent';
export const SET_MENU = 'setCategories';
export const SET_SUB_CATEGORIES = 'setSubCategories';
export const SET_ITEMS = 'setItems';

const status_obj = {
  active: {
    label: 'Active',
    color: 'tag-success',
  },
  not_active: {
    label: 'Inactive',
    color: 'tag-danger',
  },
};

const status = {
  true: {
    text: 'Active',
    color: 'tag-success',
  },
  false: {
    text: 'Inactive',
    color: 'tag-danger',
  },
};
const state = {
  home_content: {},
  menu: {},
  content_categories: {},
  items: {},
  menu_content: {},
};

const getters = {
  home_content(state) {
    return state.home_content;
  },
  content_categories(state) {
    return state.content_categories;
  },
  menu(state) {
    return state.menu;
  },
  menu_content(state) {
    return state.menu_content;
  },
  items(state) {
    return state.items;
  },
};

const actions = {
  [GET_HOMECONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/section/home', param)
        .then(async ({ data }) => {
          await context.commit(SET_HOMECONTENT, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_PARENTSECTION](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/parent-section', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [ADD_SECTIONCONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/section/home', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [ADD_MENU_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/setting/v1/menus/contents', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [ADD_ITEM_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/setting/v1/menus/contents/items', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [ADD_CATEGORY_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post('api/setting/v1/menus/contents/categories', param)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_SECTIONCONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/section/home/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DELETE_SECTIONCONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`api/section/home/${param.id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_SECTIONCONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/section/home/${param.id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_MENU](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/setting/v1/menus/contents', param)
        .then(async ({ data }) => {
          await context.commit(SET_MENU, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_MENU_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/setting/v1/menus/contents/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_ITEM_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/setting/v1/menus/contents/items/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_CATEGORY_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.put(`api/setting/v1/menus/contents/categories/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_STATUS_CATEGORY_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/setting/v1/menus/contents/categories/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_STATUS_MENU_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/setting/v1/menus/contents/menus/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [UPDATE_STATUS_ITEM_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/setting/v1/menus/contents/items/${param._id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_MENU_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/setting/v1/menus/contents/${param._id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_ITEM_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/setting/v1/menus/contents/items/${param._id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [DETAIL_CATEGORY_CONTENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/setting/v1/menus/contents/categories/${param._id}`)
        .then(async ({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_SUB_CATEGORIES](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/setting/v1/menus/contents/categories', param)
        .then(async ({ data }) => {
          await context.commit(SET_SUB_CATEGORIES, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  [GET_ITEMS](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/setting/v1/menus/contents/items', param)
        .then(async ({ data }) => {
          await context.commit(SET_ITEMS, data.data);
          resolve(data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const mutations = {
  [SET_HOMECONTENT](state, data) {
    data.rows = data.rows.map((v) => {
      v.section_name = v.home_section.section_name;
      ['created_at', 'updated_at'].forEach((kv) => {
        if (v[kv]) v[`${kv}_str`] = moment(v[kv]).format('DD/MM/YYYY');
      });
      v.status_str = status_obj[v.status].label;
      v.status_color = status_obj[v.status].color;
      return v;
    });
    state.home_content = data;
  },
  [SET_MENU](state, data) {
    data.rows = data.rows.map((v) => {
      v.status_str = status[v.status].text;
      v.status_color = status[v.status].color;
      return v;
    });
    state.menu = data;
  },
  [SET_SUB_CATEGORIES](state, data) {
    data.rows = data.rows.map((v) => {
      v.status_str = status[v.status].text;
      v.status_color = status[v.status].color;
      return v;
    });
    state.content_categories = data;
  },
  [SET_ITEMS](state, data) {
    data.rows = data.rows.map((v) => {
      v.status_str = status[v.status].text;
      v.status_color = status[v.status].color;
      v.updated_at_str = v.updated_at
        ? moment(v.updated_at).utcOffset(7).format('DD MMM YYYY, HH:mm')
        : '-';
      return v;
    });
    state.items = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
